import { render, staticRenderFns } from "./classification.vue?vue&type=template&id=215547ef&scoped=true&"
import script from "./classification.vue?vue&type=script&lang=js&"
export * from "./classification.vue?vue&type=script&lang=js&"
import style0 from "./classification.vue?vue&type=style&index=0&id=215547ef&scoped=true&lang=less&"
import style1 from "./classification.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215547ef",
  null
  
)

export default component.exports